import { render, staticRenderFns } from "./Router.vue?vue&type=template&id=a9db3456&scoped=true"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9db3456",
  null
  
)

export default component.exports